import { FREE_MEETING_MAX_DURATION_SECONDS } from '../../../utils/plan.ts';

export interface RoomTimePolicy {
  startedAt: number;
  limitSeconds: number;
}

const STORAGE_PREFIX = 'tbkmeet_room_policy_';

export function roomPolicyStorageKey(meetingId: string): string {
  return `${STORAGE_PREFIX}${meetingId}`;
}

export function readRoomTimePolicy(meetingId: string): RoomTimePolicy | null {
  try {
    const raw = sessionStorage.getItem(roomPolicyStorageKey(meetingId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as RoomTimePolicy;
    if (
      typeof parsed.startedAt === 'number' &&
      typeof parsed.limitSeconds === 'number' &&
      parsed.limitSeconds > 0
    ) {
      return parsed;
    }
  } catch {
    /* ignore */
  }
  return null;
}

export function writeRoomTimePolicy(meetingId: string, policy: RoomTimePolicy): void {
  sessionStorage.setItem(roomPolicyStorageKey(meetingId), JSON.stringify(policy));
}

export function createRoomTimePolicy(
  limitSeconds: number = FREE_MEETING_MAX_DURATION_SECONDS,
  startedAt: number = Date.now()
): RoomTimePolicy {
  return { startedAt, limitSeconds };
}

export function getElapsedSeconds(policy: RoomTimePolicy, now = Date.now()): number {
  return Math.max(0, Math.floor((now - policy.startedAt) / 1000));
}

export function getRemainingSeconds(policy: RoomTimePolicy, now = Date.now()): number {
  return Math.max(0, policy.limitSeconds - getElapsedSeconds(policy, now));
}

export function isPolicyExpired(policy: RoomTimePolicy, now = Date.now()): boolean {
  return getRemainingSeconds(policy, now) <= 0;
}
